module.exports = __webpack_public_path__ + "img/25.2c8b5fa4.jpg";